import { actionConst } from '../constants/contractor.constants';

const defaultState = {
	contractors: [],
	documentContractors: [],
}

export default (state = defaultState, action = {}) => {
	switch (action.type) {
		case actionConst.FETCH_CONTRACTORS + '_FULFILLED': {
			return {
				...state,
				contractors: action.payload.data.data || action.payload.data
			}
		}
		case actionConst.FETCH_DOCUMENT_CONTRACTORS + '_FULFILLED': {
			return {
				...state,
				documentContractors: action.payload.data.data || action.payload.data
			}
		}

		default:
			return state;
	}
}